<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 14 14" :class="[`${prefix}-icon`, `${prefix}-icon-limit`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_bee912d79e__a"><rect width="14" height="14" rx="0"/></clipPath></defs><g clip-path="url(#svg_bee912d79e__a)"><path d="M7.25771,12.6034078125L11.28822,6.5721778125C11.44647,6.3352078125,11.38229,6.0149478125,11.14458,5.8570778125C11.05977,5.8006478125,10.9601,5.7705478125,10.85815,5.7705978125L7.68912,5.7705978125L7.68912,1.9736818125C7.68912,1.6889468125,7.45779,1.4580078125,7.17237,1.4580078125C6.9995,1.4580078125,6.83823,1.5441490125,6.7423,1.6876058125L2.7117934,7.7188378125C2.5535432,7.9558078125,2.61771688,8.2758978125,2.85526,8.4339378125C2.940157,8.4904378125,3.039882,8.5205878125,3.141858,8.5205878125L6.3108900000000006,8.5205878125L6.3108900000000006,12.3173078125C6.3108900000000006,12.6021078125,6.54222,12.8330078125,6.82764,12.8330078125C7.00051,12.8330078125,7.16195,12.7469078125,7.25771,12.6034078125Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconLimit',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
